import Row from 'components/Layout/Row';
import { ReactNode } from 'react';
import Divider from '@mui/material/Divider';
import { styled, Theme } from '@mui/material/styles';
import Menu, { TabsMenuProps } from './Menu';
import Box from '@mui/material/Box';

const StyledContainer = styled(Box)(() => ({
  width: '244px',
  flexShrink: 0,
}));

type VerticalTabsProps<T extends string> = {
  spacing?: keyof Theme['spacingSizes'];
  renderContent: (tab: T) => ReactNode;
} & TabsMenuProps<T>;

const VerticalTabs = <T extends string>({
  tabs,
  selectedTab,
  spacing = 'xl',
  menuProps,
  onTabChange,
  renderContent,
}: VerticalTabsProps<T>): JSX.Element => {
  return (
    <Row spacing={spacing} fullWidth>
      <StyledContainer>
        <Menu
          menuProps={menuProps}
          tabs={tabs}
          selectedTab={selectedTab}
          onTabChange={onTabChange}
        />
      </StyledContainer>

      <Divider orientation="vertical" flexItem />
      {renderContent(selectedTab)}
    </Row>
  );
};

export default VerticalTabs;
